import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// Live match clock — counts up from started_at; freezes at ended_at.
export default function MatchClock({ startedAt, endedAt, className, iconClass = "w-3.5 h-3.5" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (endedAt || !startedAt) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [endedAt, startedAt]);

  if (!startedAt) return null;
  const end = endedAt ? new Date(endedAt).getTime() : now;
  const secs = Math.max(0, Math.floor((end - new Date(startedAt).getTime()) / 1000));
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  return (
    <span className={`inline-flex items-center gap-1 mono ${className || ""}`} data-testid="match-clock">
      <Clock className={iconClass} /> {mm}:{ss}
    </span>
  );
}
